import React from 'react';
import { Modal } from 'react-bootstrap';
import { Chart } from 'react-google-charts';

export const ExtractChartData = (data) => {
  if (!data || !data.dimensionHeaders || !data.metricHeaders || !data.rows) {
    return [];
  }

  const dimensionHeaders = data.dimensionHeaders.map((header) => header.name);
  const metricHeaders = data.metricHeaders.map((header) => header.name);

  const chartData = [dimensionHeaders.concat(metricHeaders)];

  data.rows.forEach((row) => {
    const dimensionValues = row.dimensionValues.map((dimension) => dimension.value);
    const metricValues = row.metricValues.map((metric) => parseInt(metric.value));
    const rowData = dimensionValues.concat(metricValues);
    chartData.push(rowData);
  });

  return chartData.slice(0, 10);
};

export const ChartPopup = ({ show, onHide, chartData, titleChart }) => {
  return (
    <Modal size="lg" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title> {titleChart} </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Chart
          chartType="BarChart"
          width="100%"
          height="500px"
          data={chartData}
        />
      </Modal.Body>
    </Modal>
  );
};